import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

import { getGridItemWidth } from '@/utils/gridItemWidth';

const GRID_GAP = theme.spacing[4];

export const styles = StyleSheet.create((colors, rt) => ({
  container: {
    flex: 1,
  },
  rowGrid: {
    gap: GRID_GAP,
    justifyContent: 'flex-start',
  },
  columnGrid: {
    gap: GRID_GAP,
    justifyContent: 'flex-start',
  },
  gridItem: (numColumns: number) => {
    const itemWidth = getGridItemWidth({
      screenWidth: Math.min(theme.breakpoints.tablet, rt.screen.width),
      horizontalPadding: theme.spacing[5] * 2,
      gap: GRID_GAP,
      numColumns,
    });
    const itemAspectRatio = 3 / 4;

    return {
      width: itemWidth,
      height: itemWidth / itemAspectRatio,
    };
  },
  cardContainer: {
    flex: 1,
    borderRadius: theme.borderRadius.m,
    paddingHorizontal: theme.spacing[5],
    paddingVertical: theme.spacing[6],
    gap: theme.spacing[4],
    borderWidth: 1,
    borderColor: colors.borderPrimary,
    backgroundColor: 'transparent',
    alignItems: 'center',
    justifyContent: 'center',
  },
  separatorSkeleton: {
    width: '20%',
    height: 1,
    backgroundColor: colors.borderPrimary,
    borderRadius: theme.borderRadius.xs,
  },
  listContentContainer: {
    gap: theme.spacing[3],
  },
  listCardContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: theme.spacing[5],
    gap: theme.spacing[7],
    borderRadius: theme.borderRadius.m,
    borderWidth: 1,
    borderColor: colors.borderPrimary,
    backgroundColor: 'transparent',
  },
  listCardContent: {
    flex: 1,
    gap: theme.spacing[2],
  },
}));
